import { type FunctionComponent, type PropsWithChildren } from 'react';
import React from 'react';
import { Provider } from 'react-redux';
import { type Store } from 'redux';
import { createStore } from 'redux';

import { type RootActionTypes, type RootState } from '../rootReducer';
import { rootReducer } from '../rootReducer';

export const store: Store<RootState, RootActionTypes> = createStore(rootReducer);

const WithStore: FunctionComponent<PropsWithChildren> = ({ children }) => <Provider store={store}>{children}</Provider>;

export default WithStore;
